import React from 'react'

import { useHistory } from "react-router-dom"

import { Box, FormControl, InputLabel, Select, TextField, MenuItem } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton';
import TableRowsIcon from '@mui/icons-material/TableRows';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ptBR from 'dayjs/locale/pt-br';
import { ptBR as localePTBR } from '@mui/x-date-pickers/locales';
import dayjs from 'dayjs';

import { buildColumns, get_report_values, get_report_data, initialize_date_parameters } from './detailed_register_functions'
import { getSession } from '../../../auth'

export const number2dayweek = {
    0: 'D',
    1: 'S',
    2: 'T',
    3: 'Q',
    4: 'Q',
    5: 'S',
    6: 'S'
}

const periodTypes = {
    day: 'Dia',
    range: 'Intervalo',
    month: 'Mês'
}

const aggregationOptions = {
    30: '30 minutos',
    60: '1 hora'
}

const getQueueOptions = () => {
    const user = getSession()
    const queues = user?.profile?.queues || []
    return [
        { name: '', description: 'Todos' },
        ...queues.map(queue => ({
            name: queue.name,
            description: queue.description || queue.name
        }))
    ]
}

const DetailedRegisterLeftMenu = ({ parent, setParent, disabled = false }) => {

    const history = useHistory()

    const updateParameters = (parameters) => {
        setParent({
            parameters: {
                ...parent.parameters,
                ...parameters
            }
        })
    }

    const breakDateTime = (e, format) => {
        updateParameters({
            [`date__${format}`]: e.format('YYYY-MM-DD'),
            [`time__${format}`]: e.format('HH:mm')
        })
    }

    const getDateSelector = () => {
        switch (parent.selected_report_name?.data_type) {
            case "interval":
                return (<>
                    <LocalizationProvider sx={{ justifyContent: 'space-between' }} dateAdapter={AdapterDayjs} adapterLocale={ptBR}
                        localeText={localePTBR.components.MuiLocalizationProvider.defaultProps.localeText}>
                        <Box>
                            <DateTimePicker
                                sx={{ width: '100%', minWidth:'13rem' }}
                                label={'Início'}
                                format={'DD/MM/YYYY HH:mm'}
                                slotProps={{ textField: { size: 'small' } }}
                                value={dayjs(`${parent.parameters.date__gte}T${parent.parameters.time__gte}`)}
                                onChange={e => breakDateTime(e, 'gte') }
                                disabled={disabled}
                                dayOfWeekFormatter={(n,date) => number2dayweek[date.$W]}
                                ampm={false}
                            />
                        </Box>
                        <Box>
                            <DateTimePicker
                                 sx={{ width: '100%', minWidth:'13rem' }}
                                label={'Fim'}
                                format={'DD/MM/YYYY HH:mm'}
                                slotProps={{ textField: { size: 'small' } }}
                                value={dayjs(`${parent.parameters.date__lte}T${parent.parameters.time__lte}`)}
                                onChange={e => breakDateTime(e, 'lte') }
                                disabled={disabled}
                                dayOfWeekFormatter={(n,date) => number2dayweek[date.$W]}
                                ampm={false}
                            />
                        </Box>
                    </LocalizationProvider>
                </>)
            case "month-year":
                return (<Box>
                    <LocalizationProvider sx={{ justifyContent: 'space-between' }} dateAdapter={AdapterDayjs} adapterLocale={ptBR}
                        localeText={localePTBR.components.MuiLocalizationProvider.defaultProps.localeText}
                    >
                        <DatePicker
                            sx={{ width: '100%' }}
                            label={'Mês e ano'}
                            views={['month', 'year']}
                            format={"MMMM, YYYY"}
                            slotProps={{ textField: { size: 'small' } }}
                            value={dayjs(`${parent.parameters.year}-${parent.parameters.month}`)}
                            onChange={e => updateParameters({ month: e.$M + 1, year: e.$y })}
                            disabled={disabled}
                        />
                    </LocalizationProvider>
                </Box>)
            case "day-range-month":
                return (<>
                    <LocalizationProvider sx={{ justifyContent: 'space-between' }} dateAdapter={AdapterDayjs} adapterLocale={ptBR}
                        localeText={localePTBR.components.MuiLocalizationProvider.defaultProps.localeText}
                    >
                        <Box>
                            <FormControl size="small" sx={{ minWidth: '10rem' }}>
                                <InputLabel id="queue-statistics-period-type">Filtro</InputLabel>
                                <Select
                                    labelId="queue-statistics-period-type"
                                    value={parent.parameters.period_type || 'day'}
                                    label="Filtro"
                                    onChange={e => {
                                        const periodType = e.target.value
                                        const now = dayjs()
                                        updateParameters({
                                            period_type: periodType,
                                            ...(periodType === 'month' ? { month: now.$M + 1, year: now.$y } : {})
                                        })
                                    }}
                                    disabled={disabled}
                                >
                                    {Object.entries(periodTypes).map(([key, value]) => <MenuItem key={key} value={key}>{value}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Box>
                        {(parent.parameters.period_type || 'day') === 'day' && (
                            <Box>
                                <DatePicker
                                    sx={{ width: '100%', maxWidth: '10rem' }}
                                    label={'Dia'}
                                    views={['day', 'month', 'year']}
                                    format={'DD/MM/YYYY'}
                                    slotProps={{ textField: { size: 'small' } }}
                                    value={dayjs(parent.parameters.day || parent.parameters.date__gte)}
                                    onChange={e => updateParameters({
                                        day: e.format('YYYY-MM-DD'),
                                        date__gte: e.format('YYYY-MM-DD'),
                                        date__lte: e.format('YYYY-MM-DD')
                                    })}
                                    disabled={disabled}
                                    dayOfWeekFormatter={(n,date) => number2dayweek[date.$W]}
                                />
                            </Box>
                        )}
                        {parent.parameters.period_type === 'range' && (<>
                            <Box>
                                <DatePicker
                                    sx={{ width: '100%', maxWidth: '10rem' }}
                                    label={'De'}
                                    views={['day', 'month', 'year']}
                                    format={'DD/MM/YYYY'}
                                    slotProps={{ textField: { size: 'small' } }}
                                    value={dayjs(parent.parameters.date__gte)}
                                    onChange={e => updateParameters({ date__gte: e.format('YYYY-MM-DD') })}
                                    disabled={disabled}
                                    dayOfWeekFormatter={(n,date) => number2dayweek[date.$W]}
                                />
                            </Box>
                            <Box>
                                <DatePicker
                                    sx={{ width: '100%', maxWidth: '10rem' }}
                                    label={'Até'}
                                    views={['day', 'month', 'year']}
                                    format={'DD/MM/YYYY'}
                                    slotProps={{ textField: { size: 'small' } }}
                                    value={dayjs(parent.parameters.date__lte)}
                                    onChange={e => updateParameters({ date__lte: e.format('YYYY-MM-DD') })}
                                    disabled={disabled}
                                    dayOfWeekFormatter={(n,date) => number2dayweek[date.$W]}
                                />
                            </Box>
                        </>)}
                        {parent.parameters.period_type === 'month' && (
                            <Box>
                                <DatePicker
                                    sx={{ width: '100%', maxWidth: '13rem' }}
                                    label={'Mês e ano'}
                                    views={['month', 'year']}
                                    format={'MMMM, YYYY'}
                                    slotProps={{ textField: { size: 'small' } }}
                                    value={dayjs(`${parent.parameters.year || dayjs().$y}-${parent.parameters.month || dayjs().$M + 1}`)}
                                    onChange={e => updateParameters({ month: e.$M + 1, year: e.$y })}
                                    disabled={disabled}
                                    dayOfWeekFormatter={(n,date) => number2dayweek[date.$W]}
                                />
                            </Box>
                        )}
                        <Box>
                            <FormControl size="small" sx={{ minWidth: '9rem' }}>
                                <InputLabel id="queue-statistics-aggregation">Agrupar</InputLabel>
                                <Select
                                    labelId="queue-statistics-aggregation"
                                    value={parent.parameters.aggregation_minutes || 30}
                                    label="Agrupar"
                                    onChange={e => updateParameters({ aggregation_minutes: Number(e.target.value) })}
                                    disabled={disabled}
                                >
                                    {Object.entries(aggregationOptions).map(([key, value]) => <MenuItem key={key} value={Number(key)}>{value}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box>
                            <FormControl size="small" sx={{ minWidth: '13rem', maxWidth: '18rem' }}>
                                <InputLabel id="queue-statistics-queue">Grupo</InputLabel>
                                <Select
                                    labelId="queue-statistics-queue"
                                    value={parent.parameters.queue_name || ''}
                                    label="Grupo"
                                    onChange={e => updateParameters({ queue_name: e.target.value })}
                                    disabled={disabled}
                                >
                                    {getQueueOptions().map(queue => <MenuItem key={queue.name || 'all'} value={queue.name}>{queue.description}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Box>
                    </LocalizationProvider>
                </>)
            default:
                return (<></>)
        }
    }

    return (
        <Box className={"report-header-left"}>
            <Box>
                <FormControl size="small" sx={{ maxWidth: '13rem' }}>
                    <InputLabel id="report-type">
                        Relatório
                    </InputLabel>
                    <Select
                        labelId="report-type"
                        id="report-type"
                        value={parent.selected_report_name}
                        label="Relatório"
                        onChange={async (event) => {
                            const report_name = event.target.value
                            if (report_name.name === "Notificações") {
                                history.push("chat?selectedTab=notifications")
                                return
                            }
                            setParent({ loading: true })
                            const temp_report_values = await get_report_values(report_name)
                            parent.parameters = initialize_date_parameters(temp_report_values?.data_type)
                            parent.offset = 0
                            parent.page = 0
                            const temp_report_data = await get_report_data({ ...parent, selected_report_name: report_name })
                            setParent({
                                ...parent,
                                report_values: temp_report_values,
                                report_data: temp_report_data,
                                loading: false,
                                selected_report_name: report_name,
                                ...buildColumns(temp_report_values, setParent),
                            })
                        }}
                        disabled={disabled}
                    >
                        {parent.report_names.map(report => <MenuItem key={report.id} value={report}>{report.name}</MenuItem>)}
                    </Select>
                </FormControl>
            </Box>
            {getDateSelector()}
            <Box>
                <LoadingButton
                    onClick={async () => {
                        setParent({ loading: true })
                        const data = await get_report_data(parent)
                        setParent({ loading: false, report_data: data, selectedData: [] })
                    }}
                    loadingPosition="start"
                    loading={parent.loading}
                    variant="contained"
                    startIcon={<TableRowsIcon />}
                    disabled={disabled}
                >
                    Pesquisar
                </LoadingButton>
            </Box>
        </Box>
    )
}

export default DetailedRegisterLeftMenu